// ── Settings → Messaging — apply the saved settings to their controls ──
//
// ⚠️ CALL THIS AGAIN AFTER THE COACH PROFILE LOADS. app.js's bindEvents()
// runs once, synchronously, before the async coaches-row fetch resolves —
// at that point _appCoachSettings is still {}, so a single call here paints
// the empty-object default (off). The IG handle, alert phone, coach name,
// credential, role and business-address fields on the same page all get a
// second application once the real settings arrive (app.js, the
// coachProfile.settings block); this function exists so the messaging
// control gets that same second pass instead of freezing on its setup-time
// default forever.
//
// Found 2026-09-18 on real data, on the auto-suspend controls this module used
// to paint as well: the owner's saved settings had the feature ON and the
// server was enforcing it, while Settings showed the switch OFF — because it
// was never repainted after bindEvents() ran. A coach reading "off" had no way
// to know clients could still be locked out. That is the defect this second
// pass exists for, and it applies to every control on the page.
//
// ⚠️ THE FILE KEEPS ITS NAME. The "suspend" in it is the old
// "Auto-Suspend on Overdue Payment" setting, removed 2026-09-18 — that whole
// feature is gone, replaced by the per-client non-payment suspension on the
// Amount owed card (modules/amount-owed/suspension-controls.js). Renaming the
// file would mean touching two import sites, two test files and the boot
// manifest for a word in a filename; the header says what it is instead.

/**
 * @typedef {object} MessagingSuspendControls
 * @property {HTMLInputElement|null} [oneWayMessaging] #s-one-way-messaging
 */

/**
 * Paint the control from a coaches.settings object. Safe to call with `{}`
 * (setup time, before the real settings exist) and again with the loaded row
 * once it arrives — the second call is what this whole module is for.
 *
 * @param {MessagingSuspendControls} controls
 * @param {Record<string, any>|null|undefined} settings coaches.settings
 * @returns {void}
 */
export function applyMessagingSuspendSettings(controls, settings) {
  const s = settings || {};
  if (controls.oneWayMessaging) controls.oneWayMessaging.checked = !!s.oneWayMessaging;
}
